import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Button,
  Circle,
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Link,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Stack,
  StackDirection,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useBreakpointValue,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { profileIcon } from "assets/images";
import {
  getFontSize,
  getIsArabic,
  getTheme,
  setCurrnetLanguage,
  setFontSize,
  toggleTheme,
} from "features/apps/global_slice";
import { setCurrentPage } from "features/apps/non_persist_slice";
import { getSession, signOut } from "features/auth/slice";
import { useTranslation } from "languages";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppLinks } from "tools/navigations";
import { persistor, useAppDispatch, useAppSelector } from "tools/store";
import {
  createAyahNumber,
  getQuranPageBySurah,
  normalizeArabic,
} from "utils/Helpers";
import TouchableOpacity from "../common/TouchableOpacity";
import Juz_List from "./Juz_List.json";
import Surah_List from "./Surah_List.json";

const CustomeDrawer: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const userData = useAppSelector(getSession);
  // console.log("=-=-=-=", userData)

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <>
      <TouchableOpacity onClick={onOpen}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25.987"
          height="26"
          viewBox="0 0 25.987 26"
        >
          <g
            id="Group_7263"
            data-name="Group 7263"
            transform="translate(-328 -50)"
          >
            <path
              id="Vector"
              d="M18.447,0H7.553C2.821,0,0,2.821,0,7.553V18.434C0,23.179,2.821,26,7.553,26H18.434c4.732,0,7.553-2.821,7.553-7.553V7.553C26,2.821,23.179,0,18.447,0Z"
              transform="translate(328 50)"
              fill="#ecdfc9"
            />
            <path
              id="Vector-2"
              data-name="Vector"
              d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z"
              transform="translate(333.525 56.175)"
              fill="#bf8d46"
            />
            <path
              id="Vector-3"
              data-name="Vector"
              d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z"
              transform="translate(333.525 62.025)"
              fill="#bf8d46"
            />
            <path
              id="Vector-4"
              data-name="Vector"
              d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z"
              transform="translate(333.525 67.875)"
              fill="#bf8d46"
            />
          </g>
        </svg>
      </TouchableOpacity>

      <Drawer
        placement={"left"}
        onClose={onClose}
        isOpen={isOpen}
        closeOnOverlayClick
      >
        <DrawerOverlay>
          <Stack
            w={"100%"}
            h={"100%"}
            bgColor={"secondary.950"}
            opacity={0.6}
          />
        </DrawerOverlay>

        <DrawerContent
          bg="secondary.300"
          borderRadius="3xl"
          m={2}
          boxShadow="lg"
          maxW={layoutDirection === "column" ? "96%" : "850px"}
          overflowY={"hidden"}
          pos={"relative"}
        >
          {layoutDirection === "column" && (
            <Button
              variant="outline"
              h={"full"}
              pos={"absolute"}
              top={3}
              right={3}
              onClick={onClose}
              size={["sm", "md"]}
            >
              {"x"}
            </Button>
          )}
          {userData?.user ? (
            <DrawerHeader
              justifyItems={
                // layoutDirection === "column" ? "flex-start" : "center"
                "flex-start"
              }
            >
              <Stack
                align={"center"}
                // direction={layoutDirection === "column" ? "row" : "column"}
                direction={"row"}
              >
                <Image src={profileIcon} h={["50px", "130px"]} />
                <Heading
                  mt={[0, 4]}
                  fontSize={layoutDirection === "column" ? "md" : undefined}
                >
                  {`${userData?.user?.fname} ${userData?.user.lname}`}
                </Heading>
              </Stack>
            </DrawerHeader>
          ) : (
            <Stack h={10} />
          )}

          <DrawerBody p={0}>
            <Stack
              h={"100%"}
              direction={layoutDirection as StackDirection}
              overflowY={"auto"}
              className="mac-scrollbar"
            >
              <Stack
                w={layoutDirection === "column" ? "100%" : "50%"}
                h={"100%"}
              >
                <LeftSide />
              </Stack>

              <Divider
                orientation={
                  layoutDirection === "column" ? "horizontal" : "vertical"
                }
                h={"100%"}
                borderColor={"secondary.700"}
              />

              <Stack
                w={layoutDirection === "column" ? "100%" : "50%"}
                h={"100%"}
              >
                <RightSide onCallback={onClose} />
              </Stack>
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default CustomeDrawer;

const Label: React.FC<{ title: string }> = ({ title }) => {
  const isArabic = useAppSelector(getIsArabic);
  return (
    <Stack
      bgColor={"secondary.350"}
      p={2}
      my={2}
      align={isArabic ? "flex-end" : "self-start"}
    >
      <Text color={"primary.300"}>{title}</Text>
    </Stack>
  );
};

const RowBtn: React.FC<{
  list: any[];
  selected: string;
  onCallback: (res: any) => void;
}> = ({ list, selected = false, onCallback }) => {
  const translation = useTranslation();

  return (
    <HStack px={7} w={"100%"}>
      {list.map((it, index) => (
        <Button
          key={index}
          w={"100%"}
          h={[10, 12]}
          bgColor={selected === it.name ? undefined : "secondary.350"}
          border={
            selected === it.name
              ? undefined
              : "1px solid var(--chakra-colors-secondary-900)"
          }
          onClick={() => onCallback(it)}
        >
          {translation[it.title]}
        </Button>
      ))}
    </HStack>
  );
};

const LeftSide: React.FC = () => {
  const dispatch = useAppDispatch();
  const colorMode = useAppSelector(getTheme);
  const dynamicFontSize = useAppSelector(getFontSize);
  const navigation = useNavigate();
  const isArabic = useAppSelector(getIsArabic);
  const translation = useTranslation();
  const userData = useAppSelector(getSession);

  // console.log("=-=-=-", translation['al_baqarah'])

  const handleLogout = () => {
    persistor.purge();
    dispatch(signOut());
    window.location.href = "/";
  };

  const list = [
    ...(!userData?.user
      ? []
      : [
          {
            value: "edit_profile",
            icon: (
              <svg
                id="user-edit"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  id="vuesax_outline_user-edit"
                  data-name="vuesax/outline/user-edit"
                >
                  <g id="user-edit-2" data-name="user-edit">
                    <path
                      id="Vector"
                      d="M5.75,11.5A5.75,5.75,0,1,1,11.5,5.75,5.757,5.757,0,0,1,5.75,11.5Zm0-10A4.25,4.25,0,1,0,10,5.75,4.255,4.255,0,0,0,5.75,1.5Z"
                      transform="translate(6.25 1.25)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-2"
                      data-name="Vector"
                      d="M1.4,8.329a1.4,1.4,0,0,1-1-.4A1.416,1.416,0,0,1,.018,6.7l.19-1.35A2.007,2.007,0,0,1,.717,4.33L4.258.789A2.325,2.325,0,0,1,5.886,0a2.422,2.422,0,0,1,1.651.79,2.366,2.366,0,0,1,.79,1.64,2.293,2.293,0,0,1-.79,1.63L4,7.6a1.983,1.983,0,0,1-1.02.51l-1.35.19A.913.913,0,0,1,1.4,8.329ZM5.888,1.5c-.185,0-.349.128-.57.35L1.777,5.389a.39.39,0,0,0-.08.17l-.18,1.25,1.25-.18a.556.556,0,0,0,.17-.09L6.477,3c.131-.131.35-.379.35-.571a.947.947,0,0,0-.35-.58C6.233,1.6,6.057,1.5,5.888,1.5Z"
                      transform="translate(14.422 14.42)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-3"
                      data-name="Vector"
                      d="M2.767,3.687A3.977,3.977,0,0,1,.027.947a.747.747,0,0,1,1.44-.4,2.466,2.466,0,0,0,1.7,1.7.749.749,0,0,1-.2,1.47A.645.645,0,0,1,2.767,3.687Z"
                      transform="translate(17.953 15.502)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-4"
                      data-name="Vector"
                      d="M0,7.75C0,3.48,4.19,0,9.34,0a11.217,11.217,0,0,1,3.18.46.747.747,0,1,1-.43,1.43,9.677,9.677,0,0,0-2.75-.4c-4.32,0-7.84,2.8-7.84,6.25a.758.758,0,0,1-.75.76A.755.755,0,0,1,0,7.75Z"
                      transform="translate(2.66 14.25)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-5"
                      data-name="Vector"
                      d="M24,0V24H0V0Z"
                      fill="#bf8d46"
                      opacity="0"
                    />
                  </g>
                </g>
              </svg>
            ),
          },
        ]),
    {
      value: !userData?.user ? "login" : "logout",
      icon: (
        <svg
          id="logout"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g id="vuesax_outline_logout" data-name="vuesax/outline/logout">
            <g id="logout-2" data-name="logout">
              <path
                id="Vector"
                d="M6.962,20.54c-4.44,0-6.58-1.75-6.95-5.67a.751.751,0,0,1,.68-.82.765.765,0,0,1,.82.68c.29,3.14,1.77,4.31,5.46,4.31H7.1c4.07,0,5.51-1.44,5.51-5.51V7.01c0-4.07-1.44-5.51-5.51-5.51h-.13c-3.71,0-5.19,1.19-5.46,4.39A.758.758,0,0,1,0,5.76C.342,1.78,2.492,0,6.962,0h.13C12,0,14.1,2.1,14.1,7.01v6.52c0,4.91-2.1,7.01-7.01,7.01Z"
                transform="translate(8.148 1.73)"
                fill="#bf8d46"
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M.75,1.5A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0H12.13a.755.755,0,0,1,.75.75.755.755,0,0,1-.75.75Z"
                transform="translate(2.869 11.25)"
                fill="#bf8d46"
              />
              <path
                id="Vector-3"
                data-name="Vector"
                d="M3.568,7.978.218,4.628a.754.754,0,0,1,0-1.06L3.568.218a.75.75,0,0,1,1.06,1.06L1.807,4.1l2.82,2.82a.754.754,0,0,1,0,1.06.725.725,0,0,1-.53.22A.742.742,0,0,1,3.568,7.978Z"
                transform="translate(1.752 7.903)"
                fill="#bf8d46"
              />
              <path
                id="Vector-4"
                data-name="Vector"
                d="M24,0V24H0V0Z"
                fill="#bf8d46"
                opacity="0"
              />
            </g>
          </g>
        </svg>
      ),
    },
  ];

  const handleTheme = (val: string) => {
    dispatch(toggleTheme(val));
  };

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <Stack
      h={"100%"}
      overflowY={"auto"}
      // className={"no-scroll-container"}
      className="mac-scrollbar"
      gap={layoutDirection === "column" ? 0 : 2}
      justify={"space-between"}
    >
      <VStack
        align={isArabic ? "flex-end" : "flex-start"}
        gap={5}
        px={6}
        my={5}
      >
        {list.map((item, index) => (
          <TouchableOpacity
            key={index}
            flexDirection={"row"}
            gap={4}
            onClick={() => {
              if (item.value === "logout" || item.value === "login") {
                handleLogout();
              } else {
                navigation(AppLinks.PROFILE);
              }
            }}
          >
            {isArabic ? (
              <>
                <Text color={"primary.300"}>{translation[item.value]}</Text>
                {item.icon}
              </>
            ) : (
              <>
                {item.icon}
                <Text color={"primary.300"}>{translation[item.value]}</Text>
              </>
            )}
          </TouchableOpacity>
        ))}
      </VStack>

      <Heading px={7} size={"lg"} textAlign={isArabic ? "right" : "left"}>
        {translation["quick_setting"]}
      </Heading>

      <Label title={translation["language"]} />

      <RowBtn
        list={[
          { name: "en", title: "english" },
          { name: "ar", title: "arabic" },
        ]}
        selected={isArabic ? "ar" : "en"}
        onCallback={(val) => {
          dispatch(setCurrnetLanguage(val.name));
        }}
      />

      <Label title={translation["theme"]} />

      <RowBtn
        list={[
          { name: "light", title: "light" },
          { name: "dark", title: "dark" },
        ]}
        selected={colorMode}
        onCallback={(val) => handleTheme(val.name)}
      />

      <Label title={translation["font_size"]} />

      <Text px={7} color={"secondary.700"}>
        {translation["font_size_note"]}
      </Text>

      <HStack px={7} mt={[1, 6]} pb={5}>
        <Text>A</Text>
        <Slider
          aria-label="slider-ex-2"
          defaultValue={dynamicFontSize}
          min={20}
          max={layoutDirection === "row" ? 100 : 50}
          onChange={(val) => dispatch(setFontSize(val))}
        >
          <SliderTrack bg="secondary.900">
            <SliderFilledTrack bg="primary.300" />
          </SliderTrack>
          <SliderThumb bgColor={"primary.300"} />
        </Slider>
        <Text fontSize={"2xl"}>A</Text>
      </HStack>
      <Link w="full" href="https://alquran.audio" isExternal mb={3}>
        <Button w={"full"} variant={"outline"}>
          {translation["al_quran_audio"]}
        </Button>
      </Link>
    </Stack>
  );
};

const RightSide: React.FC<{
  onCallback: () => void;
}> = ({ onCallback }) => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const isArabic = useAppSelector(getIsArabic);
  const translation = useTranslation();
  const [search, setSearch] = useState("");
  const userData = useAppSelector(getSession);

  const btnList = [
    {
      btnText: "bookmarks",
      route: AppLinks.BOOKMARK,
      icon: (
        <svg
          id="archive-minus"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g
            id="vuesax_outline_archive-minus"
            data-name="vuesax/outline/archive-minus"
          >
            <g id="archive-minus-2" data-name="archive-minus">
              <path
                id="Vector"
                d="M2.37,21.5a2.31,2.31,0,0,1-1.16-.3A2.753,2.753,0,0,1,0,18.71V4.61A4.615,4.615,0,0,1,4.61,0h9.65A4.615,4.615,0,0,1,18.87,4.61V18.7A2.751,2.751,0,0,1,17.66,21.19a2.27,2.27,0,0,1-1.162.3,3.356,3.356,0,0,1-1.608-.453l-4.88-2.71a1.436,1.436,0,0,0-1.15,0L3.98,21.04A3.373,3.373,0,0,1,2.37,21.5Zm7.07-4.787a2.728,2.728,0,0,1,1.3.307l4.881,2.71a1.83,1.83,0,0,0,.874.272.78.78,0,0,0,.406-.1,1.353,1.353,0,0,0,.47-1.2V4.61A3.113,3.113,0,0,0,14.26,1.5H4.62A3.113,3.113,0,0,0,1.51,4.61V18.7a1.33,1.33,0,0,0,.47,1.2.777.777,0,0,0,.406.1,1.83,1.83,0,0,0,.874-.272l4.88-2.71A2.732,2.732,0,0,1,9.44,16.713Z"
                transform="translate(2.56 1.25)"
                fill="#bf8d46"
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M24,0V24H0V0Z"
                fill="#bf8d46"
                opacity="0"
              />
            </g>
          </g>
        </svg>
      ),
    },
    {
      btnText: "notes",
      route: AppLinks.NOTES,
      icon: (
        <svg
          id="edit"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g id="vuesax_outline_edit" data-name="vuesax/outline/edit">
            <g id="edit-2" data-name="edit">
              <path
                id="Vector"
                d="M7.75,21.5C2.32,21.5,0,19.18,0,13.75v-6C0,2.32,2.32,0,7.75,0h2a.755.755,0,0,1,.75.75.755.755,0,0,1-.75.75h-2C3.14,1.5,1.5,3.14,1.5,7.75v6C1.5,18.36,3.14,20,7.75,20h6C18.36,20,20,18.36,20,13.75v-2a.75.75,0,0,1,1.5,0v2c0,5.43-2.32,7.75-7.75,7.75Z"
                transform="translate(1.25 1.25)"
                fill="#bf8d46"
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M2.2,16.692a2.241,2.241,0,0,1-1.58-.62,2.254,2.254,0,0,1-.589-1.949l.43-3.01a3.447,3.447,0,0,1,.869-1.74l7.88-7.88a4.33,4.33,0,0,1,3-1.492,4.33,4.33,0,0,1,3,1.492,4.182,4.182,0,0,1,1.48,3.31,4.441,4.441,0,0,1-1.48,2.68l-7.88,7.879a3.456,3.456,0,0,1-1.74.87l-3.01.43A1.693,1.693,0,0,1,2.2,16.692ZM12.2,1.5h0a2.832,2.832,0,0,0-1.927,1.047l-7.88,7.88a2.038,2.038,0,0,0-.45.89l-.43,3.01a.789.789,0,0,0,.17.68.7.7,0,0,0,.51.182,1.243,1.243,0,0,0,.171-.012l3.01-.429a2,2,0,0,0,.89-.45l7.88-7.88a3.063,3.063,0,0,0,1.04-1.77,2.776,2.776,0,0,0-1.04-2.11A2.875,2.875,0,0,0,12.2,1.505Z"
                transform="translate(6.301 0.998)"
                fill="#bf8d46"
              />
              <path
                id="Vector-3"
                data-name="Vector"
                d="M5.487,6.417A7.937,7.937,0,0,1,.027.957a.76.76,0,0,1,.52-.93.745.745,0,0,1,.92.52,6.425,6.425,0,0,0,4.42,4.42.755.755,0,0,1,.52.93.736.736,0,0,1-.72.55A.645.645,0,0,1,5.487,6.417Z"
                transform="translate(14.162 3.382)"
                fill="#bf8d46"
              />
              <path
                id="Vector-4"
                data-name="Vector"
                d="M24,0V24H0V0Z"
                fill="#bf8d46"
                opacity="0"
              />
            </g>
          </g>
        </svg>
      ),
    },
    {
      btnText: "send_feedback",
    },
  ];

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <Stack h={"100%"} w={"100%"}>
      <InputGroup pr={[0, 2]} px={layoutDirection === "column" ? 3 : undefined}>
        {isArabic ? (
          <InputRightElement pointerEvents="none" h={"100%"}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
            >
              <g id="Group_14050" data-name="Group 14050">
                <path
                  id="Vector"
                  d="M8.106,0A8.115,8.115,0,1,1,2.377,2.377,8.106,8.106,0,0,1,8.106,0Zm0,14.975a6.878,6.878,0,1,0-4.855-2.014A6.869,6.869,0,0,0,8.106,14.975Z"
                  fill="#bf8d46"
                />
                <path
                  id="Vector-2"
                  data-name="Vector"
                  d="M2.194,2.813a.616.616,0,0,1-.437-.181L.181,1.055A.618.618,0,0,1,1.055.181L2.632,1.757a.619.619,0,0,1-.438,1.055Z"
                  transform="translate(14.187 14.187)"
                  fill="#bf8d46"
                />
              </g>
            </svg>
          </InputRightElement>
        ) : (
          <InputLeftElement pointerEvents="none" h={"100%"}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
            >
              <g id="Group_14050" data-name="Group 14050">
                <path
                  id="Vector"
                  d="M8.106,0A8.115,8.115,0,1,1,2.377,2.377,8.106,8.106,0,0,1,8.106,0Zm0,14.975a6.878,6.878,0,1,0-4.855-2.014A6.869,6.869,0,0,0,8.106,14.975Z"
                  fill="#bf8d46"
                />
                <path
                  id="Vector-2"
                  data-name="Vector"
                  d="M2.194,2.813a.616.616,0,0,1-.437-.181L.181,1.055A.618.618,0,0,1,1.055.181L2.632,1.757a.619.619,0,0,1-.438,1.055Z"
                  transform="translate(14.187 14.187)"
                  fill="#bf8d46"
                />
              </g>
            </svg>
          </InputLeftElement>
        )}

        <Input
          type="text"
          placeholder={translation["search_"]}
          onChange={(v) => setSearch(v.target.value)}
          value={search}
          borderRadius={10}
          textAlign={isArabic ? "right" : "left"}
          // size='lg'
        />
      </InputGroup>

      <VStack
        h={userData?.user ? "calc(80% - 56px)" : "100%"}
        overflowY={"scroll"}
        // className={"no-scroll-container"}
        className="mac-scrollbar"
      >
        <Tabs isFitted w={"100%"} borderColor={"secondary.900"}>
          <TabList>
            <Tab _selected={{ color: "primary.300" }}>{translation["juz"]}</Tab>
            <Tab _selected={{ color: "primary.300" }}>
              {translation["surahs"]}
            </Tab>
          </TabList>
          {/* <TabIndicator height="2px" bg="primary.300" borderRadius="1px" /> */}
          <TabPanels>
            <TabPanel>
              <Accordion allowToggle w={"100%"} mb={5}>
                {Juz_List.filter(
                  (item) =>
                    item.juz.toString().includes(search) ||
                    `juz ${item.juz}`.includes(search.toLowerCase()) ||
                    `الجزء ${item.juz}`.includes(search.toLowerCase()) ||
                    item.surahs.some(
                      (surah: any) =>
                        surah.englishName
                          .toLowerCase()
                          .includes(search.toLowerCase()) ||
                        normalizeArabic(surah.name)
                          .toLowerCase()
                          .includes(normalizeArabic(search.toLowerCase()))
                    )
                ).map((item: any, index: number) => (
                  <AccordionItem key={index} w={"100%"} border={"0px"} my={2}>
                    <AccordionButton
                      py={1}
                      px={3}
                      bgColor={"secondary.350"}
                      justifyContent={isArabic ? "flex-end" : "flex-start"}
                    >
                      <Text color={"primary.300"}>{`${translation["juz"]}' ${
                        isArabic ? createAyahNumber(item?.juz) : item?.juz
                      }`}</Text>
                    </AccordionButton>
                    <AccordionPanel p={3}>
                      {(item?.surahs || []).map((it: any, ind: number) => (
                        <SurahCard
                          key={ind}
                          onClick={() => {
                            // const page = getQuranPageBySurah(it?.number.toString())
                            dispatch(setCurrentPage(it?.pageNumber));
                            onCallback();
                          }}
                          item={it}
                          ind={ind}
                        />
                      ))}
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </TabPanel>
            <TabPanel overscrollBehaviorX={"none"}>
              {Surah_List.filter(
                (item) =>
                  item.englishName
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                  normalizeArabic(item.name)
                    .toLowerCase()
                    .includes(normalizeArabic(search.toLowerCase()))
              ).map((it: any, index: number) => (
                <SurahCard
                  key={index}
                  onClick={() => {
                    const page = getQuranPageBySurah(it?.number.toString());
                    dispatch(setCurrentPage(page));
                    onCallback();
                  }}
                  item={it}
                  ind={index}
                />
              ))}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>

      {userData?.user && (
        <VStack flex={1} py={1} px={3}>
          {btnList.map((it, index) => (
            <>
              {index !== 0 && <Divider color={"secondary.700"} />}
              <TouchableOpacity
                flexDirection={"row"}
                w={"100%"}
                align={"center"}
                h={"100%"}
                justify={isArabic ? "flex-end" : "self-start"}
                onClick={() => {
                  if (it.route) {
                    navigation(it.route);
                  } else {
                    // window.open("mailto:info@alquran.network");
                    window.location.href = "mailto:info@alquran.network";
                  }
                }}
              >
                {isArabic ? (
                  <>
                    <Text color={"primary.300"}>{translation[it.btnText]}</Text>
                    {it?.icon}
                  </>
                ) : (
                  <>
                    {it?.icon}
                    <Text color={"primary.300"}>{translation[it.btnText]}</Text>
                  </>
                )}
              </TouchableOpacity>
            </>
          ))}
        </VStack>
      )}
    </Stack>
  );
};

const SurahCard: React.FC<{
  onClick: () => void;
  item: any;
  ind: number;
}> = ({ onClick, item: it, ind }) => {
  const isArabic = useAppSelector(getIsArabic);
  const translation = useTranslation();

  return (
    <TouchableOpacity
      flexDirection={"row"}
      justify={"space-between"}
      borderColor={"org_black"}
      borderWidth={0.5}
      // borderWidth={1}
      // borderColor={'secondary.700'}
      rounded={"xl"}
      p={3}
      my={2}
      onClick={onClick}
    >
      <VStack align={"flex-start"} gap={4}>
        <Text color={"primary.300"}>
          {isArabic ? it?.name : it?.englishName}
        </Text>
        <Text color={"secondary.700"}>{`${translation["no"]} ${
          isArabic ? createAyahNumber(it?.number) : it?.number
        } . ${translation["verse"]} ${
          isArabic ? createAyahNumber(it?.numberOfAyahs) : it?.numberOfAyahs
        } . ${
          it?.revelationType === "Meccan"
            ? translation["makkiyah"]
            : translation["madaniyah"]
        }`}</Text>
      </VStack>
      <Circle size="40px" bg="secondary.350">
        <Text>{isArabic ? createAyahNumber(ind + 1) : ind + 1}</Text>
      </Circle>
    </TouchableOpacity>
  );
};
